import { Component } from '@theme/component';
/** Interactive draft demonstration; no store credit or discount is issued. */
class UnboundWalletPreview extends Component {
  disconnectedCallback() {
    this.#restore();
    super.disconnectedCallback();
  }
  #restore() {
    if (!this.#selected) return;
    this.#selected = false;
    this.#render(false);
  }
  #selected = false;
  toggle(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    this.#selected = input.checked;
    this.#render(input.checked);
  }
  #render(selected) {
    const summary = this.closest('.cart-drawer__summary');
    if (!summary) return;
    const total = summary.querySelector('[data-cart-subtotal]');
    if (total) total.textContent = selected ? this.dataset.walletTotal : this.dataset.total;
    const deduction = this.querySelector('.ub-wallet-deduction');
    const note = this.querySelector('.ub-wallet-preview-note');
    if (deduction) deduction.hidden = !selected;
    if (note) note.hidden = !selected;
    const checkout = summary.querySelector('[name="checkout"]');
    if (checkout instanceof HTMLButtonElement) checkout.disabled = selected;
    const accelerated = summary.querySelector('.additional-checkout-buttons');
    if (accelerated instanceof HTMLElement) accelerated.hidden = selected;
  }
}
if (!customElements.get('unbound-wallet-preview')) customElements.define('unbound-wallet-preview', UnboundWalletPreview);
